import { Link } from '../../components/base/Link';
import { asset } from '../../lib/assets';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import BeforeAfter from '../../components/feature/BeforeAfter';
import FramePair from '../../components/feature/FramePair';
import LoopVideo from '../../components/feature/LoopVideo';
import Footer from '../../components/feature/Footer';

export default function Examples() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section with Sci-Fi Background */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-brand-navy">
          <img src={asset('/images/real/editor-objects.webp')} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-900/75 to-blue-950/70"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {t('examplesNew.heroTitle')}
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              {t('examplesNew.heroSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* 文字识别与脱敏示例 */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('examplesNew.textTitle')}</h2>
            <p className="text-lg text-gray-600">{t('examplesNew.textSubtitle')}</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* 处理前 */}
              <div className="p-8 border-r border-gray-200">
                <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                  <i className="ri-file-text-line text-blue-600 mr-2"></i>
                  {t('examplesNew.before')}
                </h3>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="text-gray-800 leading-relaxed">
                    {t('examplesNew.customerName')}：<span className="bg-red-100 px-1">{t('examplesNew.demoCustomerName')}</span><br/>
                    {t('examplesNew.idNumber')}：<span className="bg-red-100 px-1">110101199001011234</span><br/>
                    {t('examplesNew.phone')}：<span className="bg-red-100 px-1">13812345678</span><br/>
                    {t('examplesNew.homeAddress')}：<span className="bg-red-100 px-1">{t('examplesNew.demoHomeAddress')}</span><br/>
                    {t('examplesNew.emailAddress')}：<span className="bg-red-100 px-1">zhangmh@email.com</span><br/>
                    <br/>
                    {t('examplesNew.ticketNote')}：{t('examplesNew.ticketContent')}
                  </p>
                </div>
              </div>
              
              {/* 处理后 */}
              <div className="p-8">
                <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                  <i className="ri-shield-check-line text-brand-600 mr-2"></i>
                  {t('examplesNew.after')}
                </h3>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="text-gray-800 leading-relaxed">
                    {t('examplesNew.customerName')}：***<br/>
                    {t('examplesNew.idNumber')}：******************<br/>
                    {t('examplesNew.phone')}：***********<br/>
                    {t('examplesNew.homeAddress')}：*********************<br/>
                    {t('examplesNew.emailAddress')}：******************<br/>
                    <br/>
                    {t('examplesNew.ticketNote')}：{t('examplesNew.ticketContent')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 文件处理：按样本评估 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('examplesNew.fileTitle')}</h2>
            <p className="text-lg text-gray-600">{t('examplesNew.fileSubtitle')}</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h3 className="text-xl font-semibold text-gray-900 flex items-center">
                <i className="ri-file-text-line text-blue-600 mr-2"></i>
                {t('examplesNew.fileCard1Title')}
              </h3>
              <p className="mt-4 text-gray-600 leading-relaxed">{t('examplesNew.fileCard1Desc')}</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h3 className="text-xl font-semibold text-gray-900 flex items-center">
                <i className="ri-file-forbid-line text-gray-500 mr-2"></i>
                {t('examplesNew.fileCard2Title')}
              </h3>
              <p className="mt-4 text-gray-600 leading-relaxed">{t('examplesNew.fileCard2Desc')}</p>
            </div>
          </div>
          <div className="text-center mt-8">
            <Link to="/file-redaction" className="text-blue-700 underline">{t('examplesNew.fileLink')}</Link>
          </div>
        </div>
      </section>

      {/* 图片隐私遮挡前后对比：AI 原图 → 真实输出 */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('examplesNew.imageTitle')}</h2>
            <p className="text-lg text-gray-600">{t('examplesNew.imageSubtitle')}</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">{t('examplesNew.crowdTitle')}</h3>
              </div>
              <div className="p-4">
                <BeforeAfter before={asset('/images/real/ai-crowd-before.webp')} after={asset('/images/real/ai-crowd-after.webp')} beforeLabel={t('examplesNew.before')} afterLabel={t('examplesNew.after')} alt={t('examplesNew.crowdTitle')} aspectClass="aspect-[3/2]" />
                <p className="text-gray-600 text-sm mt-3">{t('examplesNew.crowdDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">{t('examplesNew.streetTitle')}</h3>
              </div>
              <div className="p-4">
                <BeforeAfter before={asset('/images/real/ai-street-before.webp')} after={asset('/images/real/ai-street-after.webp')} beforeLabel={t('examplesNew.before')} afterLabel={t('examplesNew.after')} alt={t('examplesNew.streetTitle')} aspectClass="aspect-[5/4]" />
                <p className="text-gray-600 text-sm mt-3">{t('examplesNew.streetDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">{t('examplesNew.trafficTitle')}</h3>
              </div>
              <div className="p-4">
                <BeforeAfter before={asset('/images/real/ai-traffic-before.webp')} after={asset('/images/real/ai-traffic-after.webp')} beforeLabel={t('examplesNew.before')} afterLabel={t('examplesNew.after')} alt={t('examplesNew.trafficTitle')} aspectClass="aspect-[3/2]" />
                <p className="text-gray-600 text-sm mt-3">{t('examplesNew.trafficDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">{t('examplesNew.textSign')}</h3>
              </div>
              <div className="p-4">
                <BeforeAfter before={asset('/images/real/sign-before.webp')} after={asset('/images/real/sign-after.webp')} beforeLabel={t('examplesNew.before')} afterLabel={t('examplesNew.after')} alt={t('examplesNew.textSign')} aspectClass="aspect-[1168/648]" />
                <p className="text-gray-600 text-sm mt-3">{t('examplesNew.signDesc')}</p>
              </div>
            </div>
          </div>
          <p className="mt-8 text-center text-sm text-gray-500">{t('common.aiNote')}</p>
        </div>
      </section>

      {/* 视频隐私打码：真实成片 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('examplesNew.videoTitle')}</h2>
            <p className="text-lg text-gray-600">{t('examplesNew.videoSubtitle')}</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-5 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                  <i className="ri-video-line text-brand-600 mr-2"></i>
                  {t('examplesNew.mallTitle')}
                </h3>
              </div>
              <div className="p-5">
                <LoopVideo src={asset('/media/mall-entrance-20s.mp4')} poster={asset('/media/hero-mall-poster.jpg')} label={t('examplesNew.mallTitle')} controls className="mx-auto max-w-[280px]" />
                <p className="text-gray-600 text-sm mt-4">{t('examplesNew.mallDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-5 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                  <i className="ri-user-follow-line text-brand-600 mr-2"></i>
                  {t('examplesNew.keepObject')}
                </h3>
              </div>
              <div className="p-5">
                <FramePair before={asset('/images/real/playground-1-auto.webp')} after={asset('/images/real/playground-1-keep.webp')} beforeLabel={t('examplesNew.keepBefore')} afterLabel={t('examplesNew.keepAfter')} alt={t('examplesNew.keepObject')} portrait />
                <p className="text-gray-600 text-sm mt-4">{t('examplesNew.keepDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-5 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                  <i className="ri-layout-grid-line text-brand-600 mr-2"></i>
                  {t('examplesNew.editorTitle')}
                </h3>
              </div>
              <div className="p-5">
                <img src={asset('/images/real/editor-objects.webp')} alt={t('examplesNew.editorTitle')} loading="lazy" className="w-full rounded-lg border border-gray-200" />
                <p className="text-gray-600 text-sm mt-4">{t('examplesNew.editorDesc')}</p>
              </div>
            </div>
          </div>
          <p className="mt-8 text-center text-sm text-gray-500">{t('common.sourceNote')}</p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-brand-navy">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            {t('examplesNew.ctaTitle')}
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            {t('examplesNew.ctaSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/pricing#contact" className="bg-white text-brand-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              {t('examplesNew.freeTrial')}
            </Link>
            <Link to="/pricing#contact" className="bg-brand-700 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-800 transition-colors border border-brand-600 whitespace-nowrap cursor-pointer">
              {t('examplesNew.contactSales')}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
